import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";

export default function AnimatedNumber({ value, duration = 1.0, decimals = 0, suffix = "", prefix = "" }) {
  const mv = useMotionValue(0);
  const display = useTransform(mv, (latest) => `${prefix}${Number(latest).toFixed(decimals)}${suffix}`);

  useEffect(() => {
    const controls = animate(mv, value, { duration, ease: [0.22, 1, 0.36, 1] });
    return controls.stop;
  }, [value, duration]);

  return <motion.span className="tabular-nums">{display}</motion.span>;
}
